import React from "react";
import { GetTrackProps, SliderItem } from "react-compound-slider";

// *******************************************************
// TRACK COMPONENT
// *******************************************************

type Props = { source: SliderItem; target: SliderItem; getTrackProps: GetTrackProps; disabled?: boolean };
export function MtiSliderTrack({ source, target, getTrackProps, disabled = false }: Props) {
  return (
    <div
      style={{
        position: "absolute",
        transform: "translate(0%, -50%)",
        height: 8,
        zIndex: 1,
        backgroundColor: disabled ? "#999" : "#F89723",
        borderRadius: 9,
        cursor: "pointer",
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      {...getTrackProps()}
    />
  );
}
